export default function ReviewSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50" id="reviews">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-900 mb-6 text-center">
            Is BaseTao Legit? Complete Review Guide
          </h2>
          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              Before using any shopping agent or spreadsheet resource, it is important to understand the platform&apos;s reliability, pricing transparency, shipping process, customer experience, and security considerations. Our BaseTao Review section provides detailed analysis based on available information and aggregated user experiences.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
              {[
                { label: "Reliability", desc: "Track record of consistent service delivery and order fulfillment", icon: "ri-shield-check-line" },
                { label: "Pricing Transparency", desc: "Clear cost breakdowns with no hidden fees or surprise charges", icon: "ri-price-tag-3-line" },
                { label: "Shipping Process", desc: "Streamlined logistics with tracking updates at every stage", icon: "ri-truck-line" },
                { label: "Customer Experience", desc: "Responsive support and user-friendly interface for all shoppers", icon: "ri-user-heart-line" },
              ].map((item) => (
                <div key={item.label} className="flex gap-4 p-4 rounded-xl bg-background-50">
                  <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-lg text-accent-600 w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground-900 text-sm mb-1">{item.label}</h4>
                    <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}